var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit } from '@angular/core';
import { SettingsPanelComponent } from '../settings-panel.component';
var UploadingSettingsComponent = /** @class */ (function (_super) {
    __extends(UploadingSettingsComponent, _super);
    function UploadingSettingsComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.allowedExtensions = [];
        _this.blockedExtensions = [];
        return _this;
    }
    UploadingSettingsComponent.prototype.ngOnInit = function () {
        this.allowedExtensions = this.settings.getJson('uploads.allowed_extensions', []);
        this.blockedExtensions = this.settings.getJson('uploads.blocked_extensions', []);
        this.getServerMaxUploadSize();
    };
    UploadingSettingsComponent.prototype.saveSettings = function () {
        this.setJson('uploads.allowed_extensions', this.allowedExtensions);
        this.setJson('uploads.blocked_extensions', this.blockedExtensions);
        _super.prototype.saveSettings.call(this);
    };
    UploadingSettingsComponent.prototype.getServerMaxUploadSize = function () {
        var _this = this;
        this.http.get('uploads/server-max-file-size').subscribe(function (response) {
            _this.serverMaxUploadSize = response.maxSize;
        });
    };
    return UploadingSettingsComponent;
}(SettingsPanelComponent));
export { UploadingSettingsComponent };
